import { createRouter, createWebHashHistory } from 'vue-router';

import DevView from '@/views/000-Dev.vue';
import OverviewView from '@/views/005-Overview.vue';
import SurveyView from '@/views/010-Survey.vue';
import SummaryReportView from '@/views/020-SummaryReport.vue';
import FullReportView from '@/views/030-FullReport.vue';
import ThankYouView from '@/views/040-ThankYou.vue';

const isDev = true;

const routes = [
  {
    path: '/',
    name: 'OverviewView',
    component: OverviewView,
  },
  {
    path: '/survey/:surveyIdentifier/summary/:token/:action?',
    name: 'SummaryReportView',
    component: SummaryReportView,
  },
  {
    path: '/survey/:surveyIdentifier/report/:token/:action?',
    name: 'FullReportView',
    component: FullReportView,
  },
  {
    path: '/survey/:surveyIdentifier/thank-you',
    name: 'ThankYouView',
    component: ThankYouView,
  },
  {
    path: '/survey/:surveyIdentifier',
    name: 'SurveyView',
    component: SurveyView,
  },
];

if (isDev) {
  routes.push({
    path: '/dev',
    name: 'DevMain',
    component: DevView,
    children: [
      {
        path: ':component',
        name: 'DevMainSub',
        component: DevView,
      },
    ],
  });
}

console.log('isDev', isDev);

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from) => {
  if (from.fullPath === '/') {
    return true;
  }

  if (to.fullPath === '/') {
    return false;
  }

  return true;
});

export default router;
